var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPauseTightIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_197_64495",
    maskUnits: "userSpaceOnUse",
    x: 1.5,
    y: 1.5,
    width: 17,
    height: 17,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.5,
    y: 1.5,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5H2.5V2.5H8.5V17.5ZM17.5 17.5H11.5V2.5H17.5V17.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5H2.5V2.5H8.5V17.5ZM17.5 17.5H11.5V2.5H17.5V17.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5V17.8H8.8V17.5H8.5ZM2.5 17.5H2.2V17.8H2.5V17.5ZM2.5 2.5V2.2H2.2V2.5H2.5ZM8.5 2.5H8.8V2.2H8.5V2.5ZM17.5 17.5V17.8H17.8V17.5H17.5ZM11.5 17.5H11.2V17.8H11.5V17.5ZM11.5 2.5V2.2H11.2V2.5H11.5ZM17.5 2.5H17.8V2.2H17.5V2.5ZM8.5 17.5V17.2H2.5V17.5V17.8H8.5V17.5ZM2.5 17.5H2.8V2.5H2.5H2.2V17.5H2.5ZM2.5 2.5V2.8H8.5V2.5V2.2H2.5V2.5ZM8.5 2.5H8.2V17.5H8.5H8.8V2.5H8.5ZM17.5 17.5V17.2H11.5V17.5V17.8H17.5V17.5ZM11.5 17.5H11.8V2.5H11.5H11.2V17.5H11.5ZM11.5 2.5V2.8H17.5V2.5V2.2H11.5V2.5ZM17.5 2.5H17.2V17.5H17.5H17.8V2.5H17.5Z",
    fill: "currentColor",
    mask: "url(#path-1-outside-1_197_64495)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPauseTightIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Pause_Tight_Icon.2ff5526f3008b7e9b3959547abb20ba0.svg";